<template>
    <button
            type="button"
            @click="onClickDraggableFilterTabsBtn"
            class="draggable-filter-tabs-list-btn"
    >
                <span v-if="isDraggableTabFiltersMenuOpen">
                    <Arrow :width="24" :height="24" fill="#79919c" :style="{transform: 'rotate(180deg)'}"/>
                </span>
                <span v-else>
                    <Arrow :width="24" :height="24" fill="#79919c"/>
                </span>
    </button>
</template>

<script>
    import Arrow from "@/assets/icons/arrow.svg";

    export default {
        name: "DraggableFilterTabsListBtn",
        props: ['isDraggableTabFiltersMenuOpen'],
        components: { Arrow },
        methods: {
            onClickDraggableFilterTabsBtn() {
                this.$emit('onClickDraggableFilterTabsBtn')
            }
        }
    }
</script>

<style scoped lang="less">
    .draggable-filter-tabs-list-btn {
        width: 48px;
        height: 48px;
    }
</style>